import React from "react";
import TTGrid, { COLORS } from "./TTGrid";

const AIDS = [
  ["Number lines", "M3 12h18M6 9v6M12 9v6M18 9v6"],
  ["Ten frames", "M3 7h18v10H3zM7.5 7v10M12 7v10M16.5 7v10M3 12h18"],
  ["Bar models", "M3 8h18v8H3zM9 8v8M15 8v8"],
  ["Fraction bars", "M3 6h18v5H3zM3 13h18v5H3zM12 13v5"],
  ["Place value", "M4 5h4v14H4zM10 9h4v10h-4zM16 13h4v6h-4z"],
  ["Clocks", "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM12 7v5l3 2"],
  ["Coins", "M9 4a6 6 0 1 0 0 12A6 6 0 0 0 9 4ZM15 8.3A6 6 0 1 1 9.7 19"],
  ["Arrays", "M6 6h.01M12 6h.01M18 6h.01M6 12h.01M12 12h.01M18 12h.01M6 18h.01M12 18h.01M18 18h.01"],
  ["Charts", "M4 20V4M4 20h16M8 16v-5M12 16V8M16 16v-3"],
  ["Shapes", "M12 3l8 14H4zM14 17a4 4 0 1 0 8 0"],
  ["Column methods", "M6 5h12M6 5v14M12 5v14M18 5v14M4 15h16"],
];

function Aid({ name, d }) {
  return (
    <span className="aid">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d={d} />
      </svg>
      {name}
    </span>
  );
}

export default function Modes() {
  return (
    <section className="section" style={{ paddingTop: 0 }} data-testid="modes-section">
      <div className="wrap">
        <div className="section-head">
          <span className="eyebrow rv">What we do together</span>
          <h2 className="h2 rv" style={{ "--d": "80ms" }}>
            Two ways to play. <span className="said">One</span> very confused friend.
          </h2>
        </div>

        <div className="modes">
          <article className="mode mode--maths rv">
            <span className="mode-tag">Maths · Let's solve something</span>
            <h3>Stories &amp; puzzles</h3>
            <p>
              Bake sales, pirate treasure, football scores. Real problems wrapped in silly stories,
              pitched exactly to their year group.
            </p>
            <div className="mode-visual">
              <div className="barmodel" aria-hidden>
                <div className="barmodel-q">24 cupcakes, 3 trays. How many on each?</div>
                <div className="barmodel-whole">24</div>
                <div className="barmodel-row">
                  <span>8</span>
                  <span>8</span>
                  <span>8</span>
                </div>
              </div>
            </div>
          </article>

          <article className="mode mode--tt rv" style={{ "--d": "120ms" }}>
            <span className="mode-tag">Times tables · Quick-fire facts</span>
            <h3>Times tables</h3>
            <p>Quick-fire practice that keeps coming back to the facts that are still wobbly. You choose which table, or leave it to me.</p>
            <div className="mode-visual">
              <TTGrid />
              <div className="tt-legend" aria-hidden>
                <span style={{ "--c": COLORS.secure }}>Secure</span>
                <span style={{ "--c": COLORS.wobbly }}>Wobbly</span>
                <span style={{ "--c": COLORS.new }}>Not yet</span>
              </div>
            </div>
          </article>

          <article className="mode mode--draw rv" style={{ "--d": "240ms" }}>
            <span className="mode-tag">In every chat · Pictures on cue</span>
            <h3>I draw it out</h3>
            <p>When words aren't enough, a picture pops up on screen right when it helps — and only then.</p>
            <div className="mode-visual" aria-hidden>
              <div className="tenframes">
                {[7, 5].map((filled, f) => (
                  <div className="tenframe" key={f}>
                    {Array.from({ length: 10 }, (_, k) => (
                      <i key={k} className={k < filled ? (f ? "is-b" : "is-a") : ""} style={{ "--k": k + f * 10 }} />
                    ))}
                  </div>
                ))}
              </div>
              <div className="tenframe-sum">7 + 5 = <b>12</b></div>
            </div>
          </article>
        </div>

        <div className="aids rv">
          <div>
            <h3>My box of pictures</h3>
            <p>The same models teachers use in class, so it all looks familiar.</p>
          </div>
          <div className="aid-list">
            {AIDS.map(([name, d]) => (
              <Aid key={name} name={name} d={d} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
